import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Services",       href: "#solutions"   },
  { label: "Notre approche", href: "#technologie" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open,     setOpen]     = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  return (
    <header style={{
      position: "fixed", top: 0, left: 0, right: 0, zIndex: 100,
      backdropFilter: "blur(20px)",
      WebkitBackdropFilter: "blur(20px)",
      background: scrolled ? "rgba(255,255,255,0.92)" : "rgba(255,255,255,0.80)",
      borderBottom: scrolled ? "1px solid rgba(0,0,0,0.09)" : "1px solid transparent",
      transition: "all 0.3s ease",
    }}>
      <div className="section-wrap" style={{ height: 60, display: "flex", alignItems: "center", justifyContent: "space-between" }}>

        {/* ── Logo : icône dans conteneur sombre + texte en code ── */}
        <a href="#accueil" style={{ display: "flex", alignItems: "center", gap: "10px", textDecoration: "none" }}>
          <img
            src="/images/logo.png"
            alt="aInnovation"
            style={{ height: 36, width: "auto", flexShrink: 0 }}
          />
          {/* Texte de marque */}
          <span style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontSize: "1rem",
            fontWeight: 700,
            color: "#1d1d1f",
            letterSpacing: "-0.02em",
          }}>
            a<span style={{ color: "#0071e3" }}>I</span>nnovation
          </span>
        </a>

        {/* ── Desktop nav ── */}
        <nav style={{ display: "flex", alignItems: "center", gap: "28px" }} className="hidden-mobile">
          {links.map((l) => (
            <a key={l.label} href={l.href} style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontSize: "0.875rem", fontWeight: 500,
              color: "#1d1d1f", textDecoration: "none", transition: "color 0.2s",
            }}
            onMouseEnter={e => e.target.style.color = "#0071e3"}
            onMouseLeave={e => e.target.style.color = "#1d1d1f"}>
              {l.label}
            </a>
          ))}
          <a href="#contact" className="btn-primary" style={{ padding: "9px 20px", fontSize: "0.8375rem" }}>
            Nous contacter
          </a>
        </nav>

        {/* ── Mobile toggle ── */}
        <button className="show-mobile" style={{ background: "none", border: "none", cursor: "pointer", color: "#1d1d1f" }}
                onClick={() => setOpen(!open)}>
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div style={{ background: "rgba(255,255,255,0.97)", borderTop: "1px solid rgba(0,0,0,0.07)", padding: "20px 24px 28px" }}
             className="show-mobile-flex">
          {links.map((l) => (
            <a key={l.label} href={l.href} onClick={() => setOpen(false)} style={{
              fontFamily: "'Plus Jakarta Sans'", fontSize: "1.0625rem", fontWeight: 500,
              color: "#1d1d1f", textDecoration: "none", display: "block", marginBottom: "18px",
            }}>{l.label}</a>
          ))}
          <a href="#contact" className="btn-primary" onClick={() => setOpen(false)}
             style={{ padding: "12px 24px", width: "fit-content" }}>
            Nous contacter
          </a>
        </div>
      )}

      <style>{`
        @media (min-width: 769px) {
          .hidden-mobile { display: flex !important; }
          .show-mobile { display: none !important; }
          .show-mobile-flex { display: none !important; }
        }
        @media (max-width: 768px) {
          .hidden-mobile { display: none !important; }
          .show-mobile { display: block !important; }
          .show-mobile-flex { display: flex; flex-direction: column; }
        }
      `}</style>
    </header>
  );
}
